import ActionType from 'actions/ActionType'

export default (state = { message: null, type: null }, action) => {
  switch (action.type) {
    case ActionType.SignupForm.CLOSE_SNACKBAR:
      return { message: null, type: null }
    case ActionType.SignupForm.VALIDATION_FAILURE:
      return {
        message: `${
          action.errors.length > 1 ? 'There were errors' : 'There was an error'
        }. Please double check your fields.`,
        type: 'error',
      }
    case ActionType.SignupForm.ADD_FAILURE:
      return { message: 'New form not saved. Server error', type: 'error' }
    case ActionType.SignupForm.ADD_SUCCESS:
      return { message: 'New form saved!', type: 'success' }
    case ActionType.SignupForm.UPDATE_SUCCESS:
      return { message: 'Form updated!', type: 'success' }
    case ActionType.SignupForm.UPDATE_FAILURE:
      return { message: 'Form not updated. Server error', type: 'error' }
    case ActionType.SignupForm.SCHEMA_FAILURE:
      return { message: 'Unable to load validation schema', type: 'error' }
    case ActionType.SignupForm.RECEIVE_FORM:
      return { message: null, type: null }
    default:
      return state
  }
}
